module.exports = __webpack_public_path__ + "img/16129835933.OSMEP.4acd9731.svg";